import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { VtCheckboxElement } from '@shared/dv-form/interfaces/checkbox.element';
import { VtFormElement } from '@shared/dv-form/interfaces/form.element';
import { VtNumberInputElement } from '@shared/dv-form/interfaces/number-input.element';
import { VtSpaceElement } from '@shared/dv-form/interfaces/space.element';
import { VtTextareaElement } from '@shared/dv-form/interfaces/textarea.element';
import { RouteNetwork } from '@shared/interfaces/route-network';

@Injectable({ providedIn: 'root' })
export class RouteNetworkInformationTabFormsService {
  getElements = (): VtFormElement<RouteNetwork>[] => [
    new VtTextareaElement({
      formControlParams: { key: 'Name', validators: [Validators.required] },
      labelText: 'RouteNetwork.Name',
      colspan: 12,
      row: 1,
    }),
    new VtTextareaElement({
      formControlParams: { key: 'Description' },
      labelText: 'RouteNetwork.Description',
      colspan: 12,
      row: 2,
    }),
    new VtCheckboxElement({
      formControlParams: {
        key: 'IsActive',
      },
      labelText: 'RouteNetwork.IsActive',
      elementParams: { checkboxLabel: '' },
      row: 3,
      colspan: 12,
    }),
    new VtSpaceElement({ colspan: 2, row: 4 }),
    new VtNumberInputElement({
      formControlParams: { key: 'Latitude' },
      hide: true,
    }),
    new VtNumberInputElement({
      formControlParams: { key: 'Longitude' },
      hide: true,
    }),
  ];
}
